module.exports = __webpack_public_path__ + "img/nocall1.6812f833.png";